/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kindle_Report_PrivacyInputs */

const en_kindle_report_privacy = /** @type {(inputs: Kindle_Report_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Includes playback settings and technical status. Book text, page images, and audio are not attached.`)
};

const es_kindle_report_privacy = /** @type {(inputs: Kindle_Report_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluye los ajustes de reproducción y el estado técnico. No se adjuntan texto del libro, imágenes de páginas ni audio.`)
};

/**
* | output |
* | --- |
* | "Includes playback settings and technical status. Book text, page images, and audio are not attached." |
*
* @param {Kindle_Report_PrivacyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const kindle_report_privacy = /** @type {((inputs?: Kindle_Report_PrivacyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kindle_Report_PrivacyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_kindle_report_privacy(inputs)
	return en_kindle_report_privacy(inputs)
});